




























import { Component, Vue, Prop } from 'vue-property-decorator';

import { Picture } from '../components';

import { StringOrNumber } from '@/pages/profile/utils';
import { ISimpleCard, Path, LinkAttrs } from './types';

@Component({
  components: {
    Picture,
  },
})
export default class SimpleCard extends Vue implements ISimpleCard {
  @Prop({ type: [String, Number], required: false })
  readonly id!: StringOrNumber;

  @Prop({ type: String, default: '' })
  readonly title!: string;

  @Prop({ type: String, default: '' })
  readonly image!: string;

  @Prop({ type: [String, Object], default: null })
  readonly to!: Path;

  @Prop({ type: Boolean, default: false })
  readonly finished!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly favorite!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly isFavorite!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly external!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly carousel!: boolean;

  get correctExtLink(): boolean {
    return this.external && typeof this.to === 'string';
  }

  get componentAttrs(): LinkAttrs {
    const { correctExtLink, to } = this;
    return correctExtLink
      ? { is: 'a', href: to, target: '_blank' }
      : { is: 'router-link', to };
  }

  toggle() {
    this.$emit(this.isFavorite ? 'remove' : 'toggle');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/cards/simple/Simple.vue